import {
  GetSubAccountsQueryParams,
  SubAccountStatus,
} from '@twiliointernal/e2-commons-shared-definitions';

const ID_CONSOLE_LOG_PREFIX = '[ID Console]';

const ID_CONSOLE_DEFAULT_HEADERS = {
  'Content-type': 'application/json',
};

const defaultSubaccountQueryParams: GetSubAccountsQueryParams = {
  pageSize: 10,
  status: SubAccountStatus.open,
};

export {
  ID_CONSOLE_DEFAULT_HEADERS,
  ID_CONSOLE_LOG_PREFIX,
  defaultSubaccountQueryParams,
};
